import { Music2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function PianoControls({ selected, volume, muted, onToggle, onVolume }: {
  selected: boolean; volume: number; muted: boolean; onToggle: () => void; onVolume: (value: number) => void;
}) {
  const { t } = useTranslation();
  return <div className="piano-controls">
    <button className="piano-toggle" aria-pressed={selected} disabled={muted} onClick={onToggle}>
      <Music2 size={22} strokeWidth={1.4} /><span><strong>{t('sounds.piano')}</strong><small>{t(muted ? 'sounds.enableHint' : 'sounds.pianoNote')}</small></span><span className={`switch ${selected ? 'on' : ''}`} aria-hidden="true" />
    </button>
    <div className="piano-volume"><label htmlFor="piano-volume">{t('sounds.volume', { sound: t('sounds.piano') })}</label><input id="piano-volume" type="range" min="0" max="100" value={volume * 100} onChange={event => onVolume(Number(event.target.value) / 100)} /><span>{Math.round(volume * 100)}</span></div>
    <p className="music-credit">{t('sounds.pianoCredit')} <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noreferrer">{t('sounds.pianoLicense')}</a></p>
    <p className="music-credit"><a href="https://sfzinstruments.github.io/pianos/salamander/" target="_blank" rel="noreferrer">{t('sounds.pianoSource')}</a></p>
  </div>;
}
